var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"float-right",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.pagination.per_page,"pager-count":5,"total":_vm.pagination.total,"current-page":_vm.pagination.current_page},on:{"current-change":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }